import { animate, style, transition, trigger } from '@angular/animations';

export const slideRevealAnimation = trigger('slideRevealAnimation', [
  transition(':enter', [
    style({
      opacity: 0,
      transform: 'translateY(15%)'
    }),
    animate(
      '250ms ease-out',
      style({
        opacity: 1,
        transform: 'translateY(0%)'
      })
    )
  ]),
  transition(':leave', [
    animate(
      '250ms ease-out',
      style({
        opacity: 0,
        transform: 'translateY(15%)'
      })
    )
  ])
]);
